"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withExecutionContextTransport = exports.withExecutionContext = exports.getViewExecutionContext = void 0;
const env_resolver_1 = require("./env-resolver");
const getViewExecutionContext = () => ({
    imageSource: (0, env_resolver_1.getSiteCacheImageUrlByEnv)(),
    guiTextSource: (0, env_resolver_1.getTranslationUrlByEnv)(),
});
exports.getViewExecutionContext = getViewExecutionContext;
const withExecutionContext = (message) => ({
    ...message,
    context: {
        ...message.context,
        executionContext: { ...message.context?.executionContext, ...(0, exports.getViewExecutionContext)() },
    },
});
exports.withExecutionContext = withExecutionContext;
const withExecutionContextTransport = (transport) => ({
    send: (message) => transport.send((0, exports.withExecutionContext)(message)),
    onGuideMessage: (handler) => transport.onGuideMessage(handler),
});
exports.withExecutionContextTransport = withExecutionContextTransport;
